<template>
  <div class="footer-icons">
    <div>
      <!-- <span @click="$emit('reply', { reply: msg })">Reply</span> -->
      <!-- <span class="small-icon" @click="speak(msg)">Speak</span> -->
      <img class="hideinprint small-icon-h" @d-mouseenter="(e) => { e.target.src = img.reply.h }" @d-mouseleave="(e) => { e.target.src = img.reply.n }" @click="$emit('reply', { reply: msg })" src="./img/reply-touming.svg" title="Reply Message" alt="Reply Message">
      <img class="hideinprint small-icon-h" @d-mouseenter="(e) => { e.target.src = img.speaker.h }" @d-mouseleave="(e) => { e.target.src = img.speaker.n }" @click="speak(msg)" src="./img/speaker-touming.svg" title="Text to Speech" alt="Text to Speech">

      <span v-if="isRoomAdminLoggedIn">
        <img class="hideinprint small-icon" v-if="msg.isPinned" @click="togglePinned" src="./img/pin-on.svg" alt="Pinned To Top" title="Pinned To Top" >
        <img class="hideinprint small-icon" v-if="!msg.isPinned" @click="togglePinned" src="./img/pin-off.svg" alt="Not Pinned To Top" title="Not Pinned To Top">

        <img class="hideinprint small-icon" v-if="msg.goodAsk" @click="toggleGoodAsk" src="./img/star-on.svg" alt="Is a good question" title="Is a good question">
        <img class="hideinprint small-icon" v-if="!msg.goodAsk" @click="toggleGoodAsk" src="./img/star-off.svg" alt="Mark as a good question" title="Mark as a good question">

        <img class="hideinprint small-icon-h" v-if="isSenderMuted(room, msg)" @d-mouseenter="(e) => { e.target.src = img.mute.h }" @d-mouseleave="(e) => { e.target.src = img.mute.n }" @click="removeMute(room, msg)"  src="./img/mute-touming.svg" title="Un-mute User" alt="Un-mute User">
        <img class="hideinprint small-icon-h" v-if="!isSenderMuted(room, msg)" @d-mouseenter="(e) => { e.target.src = img.mute.h }" @d-mouseleave="(e) => { e.target.src = img.mute.n }" @click="addMute(room, msg)"  src="./img/unmute.svg" title="Mute User" alt="Mute User">

        <img class="hideinprint small-icon-h" @d-mouseenter="(e) => { e.target.src = img.delete.h }" @d-mouseleave="(e) => { e.target.src = img.delete.n }" @click="removeMessage(room, msg)" src="./img/delete-touming.svg" title="Delete Message" alt="Delete Message">

        <img class="hideinprint small-icon" @click="reportMessage(room, msg)" src="./img/report.svg" title="Report Message" alt="Report Message">

      </span>

      <span v-if="!isRoomAdminLoggedIn">
        <img class="hideinprint small-icon" v-if="!isRoomAdminLoggedIn && msg.goodAsk" src="./img/star-on.svg" alt="Is a good question" title="Is a good question">
        <!-- <span class="hideinprint small-icon" v-if="isSenderMuted(room, msg)">User Muted</span> -->
        <img class="hideinprint small-icon-h" v-if="isSenderMuted(room, msg)" src="./img/mute-touming.svg" title="Muted" alt="Muted">
        <img class="hideinprint small-icon" @click="reportMessage(room, msg)" src="./img/report.svg" title="Report Message" alt="Report Message">
      </span>

      <span v-if="room.sortMethod === 'vote'">
        <img class="hideinprint small-icon" src="./img/thumb-off.svg" v-if="!hasLiked(msg)" @click="likeMessage(msg)" />
        <img class="hideinprint small-icon" src="./img/thumb-on.svg" v-if="hasLiked(msg)" @click="unlikeMessage(msg)" />
        <span class="hideinprint" v-if="msg.voteUpUUID.length > 0">{{ msg.voteUpUUID.length }}</span>
      </span>

      <b><img v-if="isSenderAdmin(room, msg)" class="small-icon" src="./img/badge.svg" alt="Room Owner">{{ msg.senderName }}</b>
      <span class=""> - </span>
      <span class="">{{ momentTime }}</span>

      <!-- <span @click="$emit('toCHI', { msg: msg })">中文</span> -->
    </div>

    <!-- <div v-if="isAdmin">
    </div> -->
  </div>
</template>

<script>
import { API } from '@/yoteach2-gui/parts'
import * as eAPI from '../../SubCompos/eAPI.js'
import Artyom from 'artyom.js'

import moment from 'moment'
import { Status } from '@/yoteach2-gui/parts/index.js'
const artyom = new Artyom()

export default {
  props: {
    isRoomAdminLoggedIn: {},
    roomPW: {},
    msg: {},
    room: {},
    isAdmin: {}
  },
  computed: {
    chatter () {
      return Status.state.chatter
    }
  },
  data () {
    return {
      img: {
        reply: {
          h: require('./img/reply.svg'),
          n: require('./img/reply-touming.svg')
        },
        speaker: {
          h: require('./img/speaker.svg'),
          n: require('./img/speaker-touming.svg')
        },
        delete: {
          h: require('./img/delete.svg'),
          n: require('./img/delete-touming.svg')
        },
        mute: {
          h: require('./img/mute.svg'),
          n: require('./img/mute-touming.svg')
        }
      },
      momentTime: ''
    }
  },
  methods: {
    async reportMessage (room, msg) {
      if (window.confirm('Report?')) {
        await eAPI.reportMessage({
          data: {
            senderUUID: msg.senderUUID,
            senderName: msg.senderName,
            roomTitle: room.title,
            roomID: room._id,
            messageID: msg._id,
            messageText: (msg.text || msg.txt),
            imgURL: msg.imgURL,
            userID: this.$root.ownerID,
            earthID: this.$root.earthID,
            msgRaw: msg
          }
        })
        window.alert('message reported!')
      }
    },
    speak (msg) {
      artyom.say(msg.text || msg.txt)
    },
    removeMessage (room, msg) {
      if (!window.confirm('Do you want to remove message?')) {
        return
      }
      API.removeMessage({
        roomID: room._id,
        roomAdminPassword: this.roomPW,
        msg
      }).then((resp) => {
        this.$emit('room', resp.data)
        API.messageDeleted(resp.data)
      })
    },
    addMute (room, msg) {
      API.addMute({
        roomID: room._id,
        roomAdminPassword: this.roomPW,
        uuid: msg.senderUUID
      }).then((resp) => {
        this.$emit('room', resp.data)
        API.roomChanged(resp.data)
      })
    },
    removeMute (room, msg) {
      API.removeMute({
        roomID: room._id,
        roomAdminPassword: this.roomPW,
        uuid: msg.senderUUID
      }).then((resp) => {
        this.$emit('room', resp.data)
        API.roomChanged(resp.data)
      })
    },
    isSenderMuted (room, msg) {
      let uuid = msg.senderUUID
      let muteList = room.mutedUUIDs
      return muteList.includes(uuid)
    },
    isSenderAdmin (room, msg) {
      let uuid = msg.senderUUID
      let list = room.adminUUIDs
      return list.includes(uuid)
    },
    togglePinned () {
      this.msg.isPinned = !this.msg.isPinned
      API.setPinned({
        roomID: this.room._id,
        roomAdminPassword: this.roomPW,
        msg: this.msg
      }).then((resp) => {
        API.messageChanged(resp.data)
      })
    },
    toggleGoodAsk () {
      this.msg.goodAsk = !this.msg.goodAsk
      API.setGoodAsk({
        roomID: this.room._id,
        roomAdminPassword: this.roomPW,
        msg: this.msg
      }).then((resp) => {
        API.messageChanged(resp.data)
      })
    },
    hasLiked (msg) {
      let list = msg.voteUpUUID
      let meUUID = API.Status.state.chatter.uuid
      return list.includes(meUUID)
    },
    likeMessage (msg) {
      let meUUID = API.Status.state.chatter.uuid
      API.likeMessage({
        messageID: msg._id,
        uuid: meUUID
      })
      if (!msg.voteUpUUID.includes(meUUID)) {
        msg.voteUpUUID.push(meUUID)
      }
      API.messageChanged(msg)
    },
    unlikeMessage (msg) {
      let meUUID = API.Status.state.chatter.uuid
      API.unlikeMessage({
        messageID: msg._id,
        uuid: meUUID
      })
      if (msg.voteUpUUID.includes(meUUID)) {
        msg.voteUpUUID.splice(msg.voteUpUUID.findIndex(u => u === meUUID), 1)
      }
      API.messageChanged(msg)
    }
  },
  mounted () {
    let setMo = () => {
      if (this.msg) {
        this.momentTime = moment(this.msg.date).fromNow()
      }
    }
    setInterval(setMo, 1000)
    setMo()
  }
}
</script>

<style scoped>
.badge{
  height: 15px;
  margin-right: 3px;
}
.small-icon{
  margin-right: 3px;
  cursor: pointer;
  height: 15px;
  margin-bottom: -6px;
}
.small-icon-h{
  margin-right: 3px;
  cursor: pointer;
  height: 25px;
  margin-bottom: -10px;
  transform: scale(1.1);
}

@media print {
  .hideinprint{
    display: none !important;
  }
}

</style>
